var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 20.7126V20.7246M3.625 14.6709C3.625 16.099 3.90629 17.5132 4.45281 18.8326C4.99933 20.152 5.80038 21.3508 6.81021 22.3607C7.82005 23.3705 9.0189 24.1716 10.3383 24.7181C11.6577 25.2646 13.0719 25.5459 14.5 25.5459C15.9281 25.5459 17.3423 25.2646 18.6617 24.7181C19.9811 24.1716 21.1799 23.3705 22.1898 22.3607C23.1996 21.3508 24.0007 20.152 24.5472 18.8326C25.0937 17.5132 25.375 16.099 25.375 14.6709C25.375 13.2428 25.0937 11.8286 24.5472 10.5092C24.0007 9.1898 23.1996 7.99095 22.1898 6.98111C21.1799 5.97128 19.9811 5.17023 18.6617 4.62371C17.3423 4.07719 15.9281 3.7959 14.5 3.7959C13.0719 3.7959 11.6577 4.07719 10.3383 4.62371C9.0189 5.17023 7.82005 5.97128 6.81021 6.98111C5.80038 7.99095 4.99933 9.1898 4.45281 10.5092C3.90629 11.8286 3.625 13.2428 3.625 14.6709Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4997 16.4833C14.4774 16.0911 14.5832 15.7022 14.8012 15.3753C15.0191 15.0484 15.3374 14.8011 15.708 14.6708C16.1622 14.4971 16.5699 14.2204 16.8989 13.8624C17.228 13.5044 17.4694 13.0749 17.6043 12.6077C17.7391 12.1405 17.7637 11.6484 17.6761 11.1701C17.5884 10.6918 17.3909 10.2404 17.0992 9.85139C16.8074 9.46239 16.4294 9.14642 15.9947 8.92835C15.5601 8.71029 15.0808 8.59609 14.5946 8.59474C14.1083 8.59339 13.6284 8.70493 13.1926 8.92058C12.7567 9.13623 12.3769 9.4501 12.083 9.83748",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/Help.8c78588d84bfb92a8ebabbd722cc365e.svg";
export { ForwardRef as ReactComponent };